/**
 * Reusable data-table + sortable header components used across report pages.
 */
import { ChevronUp, ChevronDown } from "lucide-react";

export function ReportTable({ children, testid }) {
    return (
        <div className="overflow-hidden rounded-sm border border-border bg-card" data-testid={testid}>
            <div className="max-h-[calc(100vh-380px)] overflow-auto">
                <table className="w-full text-[12px]">{children}</table>
            </div>
        </div>
    );
}

export function ReportTHead({ children }) {
    return (
        <thead className="sticky top-0 z-10 bg-muted/60 text-[10px] uppercase tracking-wider text-muted-foreground backdrop-blur">
            <tr>{children}</tr>
        </thead>
    );
}

export function SortableTH({ label, field, sort, setSort, align = "left", testid }) {
    const active = sort.by === field;
    const dir = active ? sort.dir : 0;
    const toggle = () => {
        if (!field) return;
        if (!active) setSort({ by: field, dir: -1 });
        else setSort({ by: field, dir: dir === -1 ? 1 : -1 });
    };
    return (
        <th
            onClick={toggle}
            data-testid={testid || `th-${field}`}
            className={
                "px-3 py-2 font-semibold select-none " +
                (field ? "cursor-pointer hover:text-foreground " : "") +
                (align === "right" ? "text-right" : "text-left")
            }
        >
            <span className="inline-flex items-center gap-1">
                {label}
                {active && dir === -1 && <ChevronDown className="h-3 w-3" />}
                {active && dir === 1 && <ChevronUp className="h-3 w-3" />}
            </span>
        </th>
    );
}

export function FilterBar({ children }) {
    return (
        <div className="flex flex-wrap items-center gap-2 rounded-sm border border-border bg-card p-2">
            {children}
        </div>
    );
}

export function FilterSelect({ label, value, options, onChange, testid }) {
    return (
        <label className="flex items-center gap-1.5 rounded-sm bg-background px-2 py-1 text-[11px]">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                {label}
            </span>
            <select
                data-testid={testid}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="bg-background text-[12px] font-medium outline-none"
            >
                <option value="All">All</option>
                {options.map((o) => (
                    <option key={o} value={o}>
                        {o}
                    </option>
                ))}
            </select>
        </label>
    );
}

export function SearchInput({ value, onChange, placeholder, testid }) {
    return (
        <input
            data-testid={testid}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder || "Search…"}
            className="w-64 rounded-sm border border-border bg-background px-3 py-1.5 text-[12px] outline-none focus:border-primary/60"
        />
    );
}
